export const dragTypes = {
    BOOKING: 'booking'
}
